export function setupGlobalErrorHandlers() {
	//TODO décommenté avant de publier
  // Erreurs JS globales (non React)
  // window.onerror = function (message, source, lineno, colno, error) {
  //   console.error("Erreur globale capturée:", { message, source, lineno, colno, error });
  //   // Redirection vers la page d'erreur personnalisée
  //   window.location.href = "/erreur";
  // };
	//
  // // Promesses rejetées non catchées
  // window.onunhandledrejection = function (event) {
  //   console.error("Rejet de promesse non catché :", event.reason);
  //   // Redirection vers la page d'erreur personnalisée
  //   window.location.href = "/erreur";
  // };
}

type ErrorType = 'general' | 'form';

export function handleApiError(error: any, type: ErrorType = 'general'): Record<string, string[]> {
  if (error?.response?.status === 422 && error?.response?.data?.errors) {
    return error.response.data.errors as Record<string, string[]>;
  } else if (error?.response?.data?.message) {
    return { [type]: [error.response.data.message] };
  } else {
    return { [type]: ["Une erreur est survenue. Veuillez réessayer plus tard."] };
  }
}